import { lazy } from "react";
// Coding Opportunities — refactor V3 (docs/modulos/coding-opportunities/V3).
// Módulo autocontenido montado en /coding-opportunities-v2, consume el API
// /api/v2/coding-opportunities. Coexiste con el módulo legacy
// (/coding-opportunities) hasta reemplazarlo. Cuatro pantallas por rol:
// workspace (coder) · private (care coord.) · alerts (supervisor) · hcc (admin).
//
// EN DESARROLLO: oculto en producción. El módulo resuelve su propio gating —
// si CODING_OPS_V2_ENABLED es false no publica rutas, así AppRouter no
// necesita condicionales. El sidebar gatea aparte en navigationConfig.
import { CODING_OPS_V2_ENABLED, CODING_OPS_V2_BASE_PATH } from "./common/constants";

// React.lazy SIEMPRE: nada del módulo viaja en el bundle inicial.
const CodingWorkspacePage = lazy(() => import("./pages/CodingWorkspacePage"));
const PrivateOpportunitiesPage = lazy(() => import("./pages/PrivateOpportunitiesPage"));
const CodingAlertsPage = lazy(() => import("./pages/CodingAlertsPage"));
const HccCatalogPage = lazy(() => import("./pages/HccCatalogPage"));

export const codingOpportunitiesV2Routes = CODING_OPS_V2_ENABLED
  ? [
      { path: CODING_OPS_V2_BASE_PATH, element: <CodingWorkspacePage /> },
      { path: `${CODING_OPS_V2_BASE_PATH}/private`, element: <PrivateOpportunitiesPage /> },
      { path: `${CODING_OPS_V2_BASE_PATH}/alerts`, element: <CodingAlertsPage /> },
      { path: `${CODING_OPS_V2_BASE_PATH}/hcc-catalog`, element: <HccCatalogPage /> },
    ]
  : [];

export { CODING_OPS_V2_ENABLED, CODING_OPS_V2_BASE_PATH } from "./common/constants";
